import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import { NovoProvider } from './NovoContext';
import Steps from './Steps';
import S from './styles';

function Novo({ Children }) {
  const history = useHistory();

  const [value, setValue] = useState({ rota: '', tipoRequest: 'novo' });

  const doContext = () => {
    const splitPath = history.location.pathname.split('/');
    let newValue = { ...value, rota: splitPath[splitPath.length - 1] };

    if (splitPath.length > 2) {
      newValue = { ...newValue, tipoRequest: splitPath[1] };
    }
    setValue(newValue);
  };

  const initialRender = useCallback(() => {
    doContext();
  }, [history]); // eslint-disable-line

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  return (
    <NovoProvider value={value}>
      <S.Grid>
        <Steps />

        <S.Content>
          <Children />
        </S.Content>
      </S.Grid>
    </NovoProvider>
  );
}

Novo.defaultProps = {
  Children: () => null,
};

Novo.propTypes = {
  Children: PropTypes.func,
};

export default Novo;
